import { useState } from "react"
import styled from "styled-components"

import { colors } from "@minuthq/meatball-ui-react"

import { ParadiseDeviceReadingsGraph } from "src/components/Paradise/ParadiseDevices/ParadiseDeviceReadings/ParadiseDeviceReadingsGraph"
import { ParadiseSelectDeviceReadingTypeDialog } from "src/components/Paradise/ParadiseDevices/ParadiseDeviceReadings/ParadiseGraphViews/ParadiseSelectDeviceReadingTypeDialog"
import { DeviceReadingType } from "src/data/devices/types/deviceTypes"
import { TParadiseDevice } from "src/data/paradise/paradiseDevices/types/paradiseDeviceQueryTypes"
import { MoreButton } from "src/ui/GridTable/MoreButton"
import { MText } from "src/ui/MText"
import { spacing } from "src/ui/spacing"

export function ParadiseGraphViewGraph({
  device,
  deviceReadingType,
  onReadingTypeChange,
  onGraphDelete,
  dateRange,
}: {
  device: TParadiseDevice
  deviceReadingType: DeviceReadingType
  onReadingTypeChange: (readingType: DeviceReadingType) => void
  onGraphDelete: () => void
  dateRange: { startAt: Date; endAt: Date }
}) {
  const [showEditReadingType, setShowEditReadingType] = useState(false)

  return (
    <>
      <GraphViewGraphWrapper>
        <TopWrapper>
          <MText variant="subtitleS" marginBottom={spacing.M}>
            {deviceReadingType}
          </MText>
          <MoreButton
            onEdit={() => {
              setShowEditReadingType(true)
            }}
            editLabel="Change reading type"
            onDelete={onGraphDelete}
          />
        </TopWrapper>

        <ParadiseDeviceReadingsGraph
          deviceId={device.device_id}
          type={deviceReadingType}
          dateRange={dateRange}
        />
      </GraphViewGraphWrapper>

      <ParadiseSelectDeviceReadingTypeDialog
        title="Edit Graph"
        open={showEditReadingType}
        onClose={() => setShowEditReadingType(false)}
        device={device}
        initiailDeviceReading={deviceReadingType}
        onSubmit={(deviceReading) => {
          setShowEditReadingType(false)
          onReadingTypeChange(deviceReading)
        }}
      />
    </>
  )
}

const GraphViewGraphWrapper = styled.div`
  width: 100%;

  padding: ${spacing.M};
  min-height: 400px;

  border: 1px solid ${colors.divider};
  border-radius: 8px;
  overflow: hidden;
`

const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
